import { padStart } from './StringHelper';

export function idGenerator(prefix: string) {
    let id = 1;
    return () => {
        return `${prefix}${id++}`;
    };
}

// Converts an unique name based apiId back to a unique name
export function apiIdToUniqueName(prefix: string, id: number): string {
    return `${prefix}${padStart(id.toString(), 6, '0')}`;
}
